"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDisplayLevel = void 0;
var getDisplayLevel = exports.getDisplayLevel = function getDisplayLevel(kycConfig, currentLevel) {
  if (!kycConfig) return null;
  return kycConfig.levels.filter(function (kycLevel) {
    return kycLevel.level === currentLevel;
  })[0];
};